export default {
  label: {
    id: 'quantity_selector_label_accessibility',
    defaultMessage: 'Quantity of {listing} in the cart',
  },
}
